import axios from "axios";

const ApiClient = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	withCredentials: true,
	headers: {
		"Content-Type": "application/json",
	},
});

ApiClient.interceptors.request.use(
	(config) => {
		const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
		if (match) {
			config.headers["X-XSRF-TOKEN"] = decodeURIComponent(match[1]);
		}
		return config;
	},
	(error) => Promise.reject(error)
);

ApiClient.interceptors.response.use(
	(response) => response.data,
	(error) => Promise.reject(error)
);

export default ApiClient;
